import React from 'react';
import 'rc-banner-anim/assets/index.css';
import { Image } from 'antd';
import { useTranslation } from 'react-i18next';

const Content2 = (props) => {
  const { dataSource, ...restProps } = props;
  const { t,i18n } = useTranslation();
  const { titleWrapper, page, block } = dataSource;

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <div key="content2" style={{ background: '#fff', textAlign: 'center' }}>
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t(titleWrapper.children[0].children)}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              {titleWrapper.children[1].children}
            </h2>
          </div>
          <Image src={require(`@/assets/production/eLearn/eLearn-01${i18n.language === 'en' ? '_en' : ''}.png`)} />
        </div>
      </div>
    </div>
  );
};

export default Content2;
